/**
 * MCP Tools Registry - Auto-registration
 * 
 * This module automatically registers all CRM tools with the MCP server
 */

import { registerLeadTools } from './leads.mcp';
import { registerTaskTools } from './tasks.mcp';
import { registerOpportunityTools } from './opportunities.mcp';
import { registerCompanyTools } from './companies.mcp';
import { registerBriefingTools } from './briefing.mcp';
import { registerGoogleAdsTools } from './googleAds.mcp';
import { registerResearchTools } from './research.mcp';
import { registerCreativeTools } from './creative.mcp';
import { registerCustomerIntelligenceTools } from './customerIntelligence.mcp';
import { registerBrandBookTools } from './brandBook.mcp';
import { auditOptimizationTools } from './auditOptimization.mcp';
import { engagementTools } from './engagements.mcp';
import { getMCPServer } from '../server/MCPServer';

/**
 * Register all CRM tools with the MCP server
 */
export async function registerAllTools(): Promise<void> {
  console.log('🔧 Registering all MCP tools...');
  
  try {
    // Register CRM core tools
    registerLeadTools();        // 6 tools
    registerTaskTools();        // 4 tools
    registerOpportunityTools(); // 6 tools ✅ +1 add_note_to_opportunity
    registerCompanyTools();     // 5 tools
    registerBriefingTools();    // 1 tool ✅ Meeting Preparation
    
    // Register integration & specialized tools
    registerGoogleAdsTools();   // 19 tools (updated)
    registerResearchTools();    // 2 tools
    registerCreativeTools();    // 2 tools
    
    // Register Customer Intelligence tools (NEW)
    registerCustomerIntelligenceTools(); // 5 tools
    
    // Register BrandBook tools (NEW)
    registerBrandBookTools(); // 5 tools
    
    // Register Audit Optimization tools (NEW)
    registerAuditOptimizationTools(); // 3 tools
    
    // Register Engagement tools (NEW)
    registerEngagementTools(); // 6 tools
    
    console.log('✅ All MCP tools registered successfully (72 total tools)');
  } catch (error) {
    console.error('❌ Error registering MCP tools:', error);
    throw error;
  }
}

/**
 * Get list of all available tool categories
 */
/**
 * Register Audit Optimization tools
 */
function registerAuditOptimizationTools(): void {
  const mcpServer = getMCPServer();
  auditOptimizationTools.forEach(tool => {
    mcpServer.registerTool(tool);
  });
  console.log('  ✅ Audit Optimization tools registered (3 tools)');
}

/**
 * Register Engagement tools
 */
function registerEngagementTools(): void {
  const mcpServer = getMCPServer();
  engagementTools.forEach(tool => {
    mcpServer.registerTool(tool);
  });
  console.log('  ✅ Engagement tools registered (6 tools)');
}

/**
 * Get list of all available tool categories
 */
export function getToolCategories(): string[] {
  return [
    'leads',
    'tasks',
    'google-ads',
    'opportunities',
    'companies',
    'contacts',
    'activities',
    'reports',
    'search',
    'automation',
    'research',
    'creative',
    'customer-intelligence',
    'brand-book',
    'audit-optimization',
    'engagements'
  ];
}

/**
 * Get tool count by category
 */
export function getToolStats(): Record<string, number> {
  return {
    leads: 6,
    tasks: 4,
    opportunities: 6,
    companies: 5,
    briefing: 1,
    'google-ads': 25,
    research: 2,
    creative: 4,
    'customer-intelligence': 6,
    'brand-book': 5,
    'audit-optimization': 3,
    engagements: 6,
    total: 72
  };
}

